import { useListViewContext } from '@app/core/list-view/context/ListViewContext';
import { PlatformSelect } from '@app/modules/social-export/components/inputs/PlatformSelect';
import { SocialPlatformId } from '@app/modules/social-export/domain/platforms';
import { SxProps, Theme } from '@mui/material';
import { GenericParser, useQueryState } from 'nuqs';
import { MessageDescriptor, useIntl } from 'react-intl';

/**
 * Props for the platform multi-select when used as a list-view filter.
 * Parser should produce string[] (e.g. parseAsCommaSeparatedList); URL is comma-separated.
 */
export interface PlatformSelectFilterProps {
  name: string;
  label: MessageDescriptor | false;
  parser: GenericParser<string[]>;
  isActive?: boolean;
  onRemove?: () => void;
  sx?: SxProps<Theme>;
}

/**
 * List-view filter wrapper for PlatformSelect (multiple). Value is an array of platform ids;
 * the parser serializes it as a comma-separated string in the URL.
 */
export function PlatformSelectFilter({
  name,
  label,
  parser,
  isActive,
  onRemove: _onRemove,
  sx,
}: PlatformSelectFilterProps) {
  const { $t } = useIntl();
  const { setFilterValue } = useListViewContext();
  const [value] = useQueryState(name, parser);

  const ids: SocialPlatformId[] = (value ?? []) as SocialPlatformId[];

  const handleChange = (selected: SocialPlatformId[]) => {
    setFilterValue(name, selected.length ? selected : null);
  };

  if (isActive === false && !value) {
    return null;
  }

  const translatedLabel = label === false ? '' : $t(label);

  return (
    <PlatformSelect
      multiple
      value={ids}
      onChange={(val) => handleChange(val as SocialPlatformId[])}
      label={translatedLabel}
      sx={sx}
    />
  );
}
